import React from "react";

/** The agents robot mark. Its own module so the rail and copilot don't pull in the agents page. */
const BotGlyph = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4.5" y="8" width="15" height="10.5" rx="3.2" />
    <path d="M12 8V5" />
    <circle cx="12" cy="3.6" r="1.15" fill="currentColor" stroke="none" />
    <circle cx="9.3" cy="13" r="1.05" fill="currentColor" stroke="none" />
    <circle cx="14.7" cy="13" r="1.05" fill="currentColor" stroke="none" />
    <path d="M2.8 12v3M21.2 12v3" />
  </svg>
);

export default BotGlyph;
